import {
    AbsoluteTimeOffset,
    RelativeTimeOffset,
} from '@lib/iab/iab-vast-model';

import parseTime from '../util/parse-time';

interface ParseOptions {
    errorHandler: {
        tryRecover: (error: Error) => void;
    };
}

const createTimeOffset = (
    offsetStr: string,
    options: ParseOptions,
    err: Error
): AbsoluteTimeOffset | RelativeTimeOffset => {
    const lastChar = offsetStr.charAt(offsetStr.length - 1);
    if (lastChar === '%') {
        const offset = new RelativeTimeOffset();
        offset.value = parseFloat(offsetStr.substr(0, offsetStr.length - 1));
        return offset;
    } else {
        const offset = new AbsoluteTimeOffset();
        try {
            offset.value = parseTime(offsetStr);
        } catch (error) {
            options.errorHandler.tryRecover(error as Error);
        }
        return offset;
    }
};

export default createTimeOffset;
